import { IAutomationObject } from "../../automationObjects";
import { FlexGridView } from "../../automationObjects/components/Grid/FlexGridView";
import { LoadingView } from "../../components";
import { useGetRelationsOutByIdQuery } from "../../services/objects";
import DashboardItem from "./Item";
import { IDashboardCollection } from "./types";

const DashboardView = (props: { dashboard: IDashboardCollection, edit: boolean }) => {

    const { data, error, isLoading, isSuccess, isFetching, refetch } = useGetRelationsOutByIdQuery({ objectId: props.dashboard.id, resourceGroupId: props.dashboard.resourceGroupId, type: 'Includes' }, { skip: !props.dashboard });

    const handleItemRemoved = () => refetch();

    return (
        <LoadingView isLoading={isLoading || isFetching} error={error} isSucess={isSuccess}>
            <FlexGridView>
                {data?.map((item: IAutomationObject, index: number) => (

                    <DashboardItem onItemRemoved={handleItemRemoved} key={item.id} dashboard={props.dashboard} app={item} edit={props.edit}></DashboardItem>
                ))}
            </FlexGridView>
        </LoadingView>
    )
}

export default DashboardView;